import { Box } from 'approot/shared/design-system/box/box.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import * as Styled from './feedback.style';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import FeedbackSurveyModal from 'approot/shared/feedback-survey/feedback-survey-modal';
import { FeedbackFeature } from 'global/constants';
import useUserData from 'approot/shared/user/user-data';
import { INTERCOM_LAUNCH_TARGET_CLASS } from 'lib/intercom/intercom';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  text?: string;
  linkText?: string;
  buttonText?: string;
  feature: FeedbackFeature;
  ariaLabel?: string;
};

const Feedback = ({
  text,
  linkText,
  buttonText,
  feature,
  ariaLabel,
}: Props) => {
  const { openModal, isVisible, closeModal } = useSimpleModalState();
  const { isSignedIn } = useUserData();

  const handleShowSurvey = () => {
    if (!isSignedIn) {
      return;
    }
    openModal();
  };

  return (
    <>
      <FeedbackSurveyModal
        isVisible={isVisible}
        closeModal={closeModal}
        feature={feature}
      />

      {!text ? (
        <SecondaryButton
          type="button"
          aria-haspopup="dialog"
          className={!isSignedIn ? INTERCOM_LAUNCH_TARGET_CLASS : undefined}
          onClick={e => {
            e.stopPropagation();
            handleShowSurvey();
          }}
        >
          {buttonText || 'Give us Feedback'}
        </SecondaryButton>
      ) : (
        <Box $flexDirection="row" $gap={4} $justifyContent="center">
          <Text $align="center" $colour="grey" $fontSize={14}>
            {text}{' '}
            <Styled.FeedbackLink
              type="button"
              $fontWeight="medium"
              aria-haspopup="dialog"
              className={!isSignedIn ? INTERCOM_LAUNCH_TARGET_CLASS : undefined}
              aria-label={ariaLabel}
              onClick={handleShowSurvey}
            >
              {linkText || 'Give us Feedback'}
            </Styled.FeedbackLink>
          </Text>
        </Box>
      )}
    </>
  );
};

export default Feedback;
